import faradayApi from "../api/faradayApi"


export const getMyProfile = async() => {
    try {      
        const {data} = await faradayApi.get('/user/getMyProfile')
        return data
    } catch (error) {
        console.log(error)
        return {ok: false}
    }
}